import { Actor, Color, ScreenElement, vec, Vector, Text, Canvas, Label, Font, BaseAlign, TextAlign, Graphic, Engine, FontStyle } from "excalibur";
import { derived, Resources } from "../../resources";
import { LevelOne } from "../../scenes/level-one/level-one";
import { CostButton } from "./cost_button";
import { TowerSpec } from "./tower_specs";

const padding = 4;

export class TowerButton extends CostButton {
    private costLabel: Label;

    constructor(
        level: LevelOne,
        x: number,
        y: number,
        width: number,
        height: number,
        private towerSpec: TowerSpec,
        onSelect: () => void
    ) {        
        super(
            level,
            towerSpec.cost,
            onSelect,
            {
                pos: vec(x + padding, y + padding),
                width: width - padding * 2,
                height: height - padding * 2,
                color: new Color(255, 255, 255, 0.3),
            }
        );
    }

    public onInitialize() {
        super.onInitialize();

        const icon = new Actor({
            pos: vec(this.width / 2, this.height / 2 - 8),
            scale: vec(0.87, 0.87),
        });

        icon.graphics.use(
            this.towerSpec.icon
        );
        
        this.addChild(
            icon
        );

        this.costLabel = new Label({
            pos: vec(this.width / 2 - 4, this.height - padding * 6),
            text: `$${this.towerSpec.cost}`,
            font: new Font({
                size: 24,
                baseAlign: BaseAlign.Bottom,
                textAlign: TextAlign.Center,
            }),
        });

        this.addChild(
            this.costLabel
        );
    }
}